import { OperationAlertDeliveryGroup } from "../../../types/alert/operation-alert-delivery-group";
import { OperationAlertDeliveryGroupDto } from "../../../types/alert/operation-alert-delivery-group-dto";
import { convertScheduleDtoToSchedule } from "../schedule/schedule-converter";

export const convertOperationAlertDeliveryGroup = (
  operationAlertDeliveryGroupDto: OperationAlertDeliveryGroupDto
): OperationAlertDeliveryGroup => {
  const schedule = convertScheduleDtoToSchedule(
    operationAlertDeliveryGroupDto.schedule
  );
  const deliveryGroup =
    schedule.deliveryGroups[operationAlertDeliveryGroupDto.deliveryGroupIndex];

  return {
    schedule: schedule,
    deliveryGroup: deliveryGroup,
    deliveryGroupIndex: operationAlertDeliveryGroupDto.deliveryGroupIndex,
    targetClientId: operationAlertDeliveryGroupDto.targetClientId ?? null,
    isDistanceRisk: operationAlertDeliveryGroupDto.isDistanceRisk ?? false,
    distanceMeters: operationAlertDeliveryGroupDto.distanceMeters ?? null,
    remainingSeconds: operationAlertDeliveryGroupDto.remainingSeconds ?? null,
  };
};
